import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useAlert } from '../contexts/AlertContext';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useAlert();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/admin/login`, formData);
      
      // 토큰을 localStorage에 저장
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('userType', 'admin');
      
      // 관리자 정보를 가져와서 저장
      const adminResponse = await axios.get(`${API_BASE_URL}/api/auth/admin/me`, {
        headers: {
          'Authorization': `Bearer ${response.data.access_token}`
        }
      });
      localStorage.setItem('user', JSON.stringify(adminResponse.data));
      
      showSuccess('관리자 로그인이 성공적으로 완료되었습니다!');
      navigate('/admin');
      
    } catch (error) {
      console.error('Admin login error:', error);
      if (error.response?.data?.detail) {
        setError(error.response.data.detail);
      } else {
        setError('로그인 중 오류가 발생했습니다.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="login-container">
        <div className="card login-card">
          <h2>Admin Login</h2>
          <p>관리자 계정으로 로그인해주세요</p>
          
          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">관리자 아이디</label>
              <input
                type="text"
                className="form-input"
                value={formData.username}
                onChange={(e) => setFormData({...formData, username: e.target.value})}
                placeholder="관리자 아이디를 입력하세요"
                required
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">비밀번호</label>
              <input
                type="password"
                className="form-input"
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                placeholder="비밀번호를 입력하세요"
                required
              />
            </div>
            
            <div className="form-group">
              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={loading}
                style={{width: '100%'}}
              >
                {loading ? '로그인 중...' : '관리자 로그인'}
              </button>
            </div>
          </form>

          <div className="login-links">
            <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#fff3cd', borderRadius: '5px', border: '1px solid #ffeaa7'}}>
              <p style={{margin: '0', fontSize: '14px', color: '#856404'}}>
                ℹ️ <strong>기본 관리자 계정</strong><br/>
                아이디: nexpa<br/>
                비밀번호: nexpa
              </p>
            </div>
            
            <button 
              className="btn btn-secondary"
              onClick={() => navigate('/login')}
              style={{marginTop: '15px', width: '100%'}}
            >
              ← 일반 사용자 로그인
            </button>
            
            <button 
              className="btn btn-link"
              onClick={() => navigate('/')}
              style={{marginTop: '10px', width: '100%'}}
            >
              홈으로 돌아가기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage; 